import { closeModal } from "./app-modal.action";

export const closeErrorModal = () => (dispatch,getState) => {
    dispatch(closeModal());
    const state = getState()
    const callback = state && state.modalInfo && state.modalInfo.errorModalCallback ? state.modalInfo.errorModalCallback : null
    if(callback && typeof callback === "function") {
        callback()
    }
}
